import { Device } from '../../../helpers/Device'

export interface IDeviceMetadata {
  make?: string
  model?: string
  os?: string
  osv?: string
  dnt?: number
  language?: string
  devicetype?: string
  h?: number
  w?: number
  ua?: string
}

export function collectDeviceMetadata(): IDeviceMetadata {
  return {
    os: Device.os,
    osv: Device.osversion,
    dnt:
      navigator.doNotTrack == 'yes' ||
      navigator.doNotTrack == '1' ||
      navigator.msDoNotTrack == '1'
        ? 1
        : 0,
    h: screen.height,
    w: screen.width,
    ua: navigator.userAgent,
    language: navigator.language
  }
}

export function recordNextrollInfo() {
  window.$mediavine.newrelic?.addPageAction('xidCheck', {
    hasXid: window.$mediavine.xid === '1',
    os: Device.os,
    osv: Device.osversion,
    deviceType: Device.deviceType,
    browser: Device.browser,
    wrapperVersion: window.$mediavine.web.model.versionGroup.version,
    wrapperGroup: window.$mediavine.web.model.versionGroup.name
  })
}
